import {useTranslation} from "react-i18next";
import React, {useRef} from "react";
import {generateHtmlId} from "mrf/utils/StringGenerators";
import {asyncFileReader} from "mrf/view/FileField";
import {daoPut} from "mrf/Dao";
import notification, {notifyError, TYPE} from "mrf/utils/notification";
import Hidden from "styles/basic/Hidden";
import {StyledFileContainer, StyledFileLabel} from "styles/components/FileField.styles";
import {DocumentAdd} from "styled-icons/typicons";
import T from "mrf/utils/T";

export function StaticUploadButton({htmlId, accept, label, endpoint, ...props}) {
    const {t} = useTranslation();

    const refDrop = useRef(null);

    htmlId = htmlId ?? generateHtmlId("staticUploadButton", label);

    const handleChange = async e => {
        e.preventDefault?.();
        e.stopPropagation?.();
        const file = await asyncFileReader(e.target.files[0]);

        try {
            await daoPut(`${endpoint}`, file);
            notification({ type: TYPE.SUCCESS, message: 'Successfully Edited' });
        } catch (e2) {
            console.error(e2);
            notifyError(t("Failed to update file"), e2,);
        }
    }

    return (<>
        <Hidden
            as='input'
            type='file'
            accept={accept}
            onChange={handleChange}
            id={htmlId}
        />
        <StyledFileContainer htmlFor={htmlId} ref={refDrop} {...props}>
            <DocumentAdd size='25'/>
            <StyledFileLabel>
                <T>{label}</T>
            </StyledFileLabel>
        </StyledFileContainer>
    </>);
}